import React from 'react'
import { LabelTooltip } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { NoticeInfo } from '@fs/zion-icon'

export default function HelpTooltip({ size = 'sm' }) {
  const [t] = useTranslation()
  return (
    <LabelTooltip
      label={t(
        'edit-index.person-details.help-tooltip-label',
        'Who the record is about. Example: In a baptismal record, the primary name would be the person who was baptized.'
      )}
      target={<NoticeInfo size={size} label="helpToolTip" name="helpToolTip" />}
    />
  )
}
